import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

interface FiltersCardProps {
    title?: string;
    children: React.ReactNode;
    actions: React.ReactNode;
    defaultOpen?: boolean;
    columns?: number;
}

const FiltersCard: React.FC<FiltersCardProps> = ({
    title = 'Filtros de Busca',
    children,
    actions,
    defaultOpen = true,
    columns = 3,
}) => {
    const [open, setOpen] = useState(defaultOpen);

    return (
        <div className="filters-card">
            <div
                className="filters-header"
                onClick={() => setOpen(o => !o)}
                style={{ cursor: 'pointer' }}
            >
                <div className="filters-title">
                    <FontAwesomeIcon icon={faFilter} className="filters-icon" />
                    <h3>{title}</h3>
                </div>
                <FontAwesomeIcon icon={open ? faChevronUp : faChevronDown} className="filters-icon" />
            </div>

            {open && (
                <>
                    <div className="filters-content">
                        <div className={`filters-grid filters-grid--${columns}`}>
                            {children}
                        </div>
                    </div>
                    <div className="filters-actions">
                        {actions}
                    </div>
                </>
            )}
        </div>
    );
};

export default FiltersCard;
